import React from 'react';
import { connect } from 'react-redux';
import { Input, DatePicker, Dropdown, PhoneInput, FileUpload } from '../../form'
import { email } from '../../form/FormValidations'
import { lowercase, capitalizeFirstLetter } from '../../form/FormNormalize';
import { FormTemplateHeader, FormTemplateField, FormTemplateSectionWrapper } from '../../others/'
import { EYE_COLORS, KNOWLEDGE_OF_OFFICE, GENDER, UPLOAD_RULES } from '../../../../itrust_common/components/Constants';
import { Field, FieldArray } from 'redux-form';
import PromotionEligibilitiesField from './PromotionEligibilitiesField';

const PersonalInformationTab = (props) => {
  const { template, isTemplate, isLongForm, userType, formName } = props

  return (
    <div>
      {template && template.personal_information &&
        <div>
          <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.basic_details}>
            <div className={`row mx-0 bg-white ${isLongForm && 'shadow-sm'}`}>
              <div className="col-12 px-5">
                <FormTemplateHeader
                  isTemplate={isTemplate}
                  fieldValues={template.personal_information.basic_details}
                  baseName="personal_information[basic_details]" />
              </div>
              <div className="col-12 px-7 pt-5">
                <div className="row">
                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="first_name"
                    normalize={capitalizeFirstLetter}
                    baseName="personal_information[basic_details][fields][first_name]"
                    fieldValues={template.personal_information.basic_details.fields.first_name}
                    component={Input}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                   />
                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="middle_name"
                    normalize={capitalizeFirstLetter}
                    baseName="personal_information[basic_details][fields][middle_name]"
                    fieldValues={template.personal_information.basic_details.fields.middle_name}
                    component={Input} 
                    className="form-control" 
                    wrapperClasses="col-6 form-group"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="last_name"
                    normalize={capitalizeFirstLetter}
                    baseName="personal_information[basic_details][fields][last_name]"
                    fieldValues={template.personal_information.basic_details.fields.last_name}
                    component={Input}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="cell_phone"
                    baseName="personal_information[basic_details][fields][cell_phone]"
                    fieldValues={template.personal_information.basic_details.fields.cell_phone}
                    component={PhoneInput}
                    isPhoneInput={true}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="home_phone"
                    baseName="personal_information[basic_details][fields][home_phone]"
                    fieldValues={template.personal_information.basic_details.fields.home_phone}
                    component={PhoneInput}
                    isPhoneInput={true}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="office_phone"
                    baseName="personal_information[basic_details][fields][office_phone]"
                    fieldValues={template.personal_information.basic_details.fields.office_phone}
                    component={PhoneInput}
                    isPhoneInput={true}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="email" normalize={lowercase}
                    baseName="personal_information[basic_details][fields][email]"
                    fieldValues={template.personal_information.basic_details.fields.email}
                    component={Input}
                    validate={[email]}
                    className="form-control"
                    wrapperClasses="col-6 form-group"
                  />

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="date_of_birth"
                    baseName="personal_information[basic_details][fields][date_of_birth]"
                    fieldValues={template.personal_information.basic_details.fields.date_of_birth}
                    component={DatePicker}
                    wrapperClasses="col-6 form-group"
                  />
                  {userType === "Staff" && <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="recall_reminder_date"
                    baseName="personal_information[basic_details][fields][recall_reminder_date]"
                    fieldValues={template.personal_information.basic_details.fields.recall_reminder_date}
                    component={DatePicker}
                    min={new Date()}
                    wrapperClasses="col-6 form-group"
                  />
                  }

                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="gender"
                    baseName="personal_information[basic_details][fields][gender]"
                    fieldValues={template.personal_information.basic_details.fields.gender}
                    type="radioGroup"
                    wrapperClasses="col-6"
                    options={GENDER}
                  />
                  <Field type='file' label="Avatar" name="avatar_attributes" component={FileUpload} wrapperClasses="col-6 form-group error" imageClasses="py-3 px-5 uploaded-file-width" accept={UPLOAD_RULES.avatar.accept} />
                  <FormTemplateField
                    isTemplate={isTemplate}
                    isOpen={true}
                    name="mode_of_notification_type"
                    baseName="personal_information[basic_details][fields][mode_of_notification_type]"
                    fieldValues={template.personal_information.basic_details.fields.mode_of_notification_type}
                    type="mode_of_notification"
                    formName={formName}
                    wrapperClasses="col-6"
                  />

                </div>
              </div>
            </div>
          </FormTemplateSectionWrapper>
          {isLongForm === true &&
            [<FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.other_details}>
              <div className="row mx-0  bg-white shadow-sm">
                <div className="col-12 px-5 py-5">
                  <FormTemplateHeader
                    isTemplate={isTemplate}
                    fieldValues={template.personal_information.other_details}
                    baseName="personal_information[other_details]" />
                </div>
                <div className="col-12 px-7 pt-5">
                  <div className="row">
                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="nickname"
                      baseName="personal_information[other_details][fields][nickname]"
                      fieldValues={template.personal_information.other_details.fields.nickname}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="ethnicity"
                      baseName="personal_information[other_details][fields][ethnicity]"
                      fieldValues={template.personal_information.other_details.fields.ethnicity}
                      component={Dropdown}
                      data={template.personal_information.other_details.fields.ethnicity.default_values}
                      valueField="value"
                      textField="value"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="eye_color"
                      baseName="personal_information[other_details][fields][eye_color]"
                      fieldValues={template.personal_information.other_details.fields.eye_color}
                      component={Dropdown}
                      data={EYE_COLORS}
                      valueField="value"
                      textField="label"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="occupation"
                      baseName="personal_information[other_details][fields][occupation]"
                      fieldValues={template.personal_information.other_details.fields.occupation}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="employer"
                      baseName="personal_information[other_details][fields][employer]"
                      fieldValues={template.personal_information.other_details.fields.employer}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="ssn"
                      baseName="personal_information[other_details][fields][ssn]"
                      fieldValues={template.personal_information.other_details.fields.ssn}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="interest"
                      baseName="personal_information[other_details][fields][interest]"
                      fieldValues={template.personal_information.other_details.fields.interest}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />
                    {isTemplate && (
                      <FormTemplateField
                        isTemplate={isTemplate}
                        isOpen={true}
                        name="promotion_eligibility"
                        baseName="personal_information[other_details][fields][promotion_eligibility]"
                        fieldValues={template.personal_information.other_details.fields.promotion_eligibility}
                        component={Dropdown}
                        data={template.personal_information.other_details.fields.promotion_eligibility.default_values}
                        valueField="value"
                        textField="value"
                        wrapperClasses="col-6 form-group"
                      />
                    )}
                  </div>
                </div>
              </div>
            </FormTemplateSectionWrapper>,

            !isTemplate && (
              <FieldArray
                name="promotion_eligibilities"
                component={PromotionEligibilitiesField}
                rerenderOnEveryChange
                formName={formName || 'patientForm'}
                fieldValues={template.personal_information.other_details.fields.promotion_eligibility}
                data={template.personal_information.other_details.fields.promotion_eligibility?.default_values}
              />
            ),

            <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.knowledge_of_office}>
              <div className="row mx-0 bg-white shadow-sm">
                <div className="col-12 px-5 py-5">
                  <FormTemplateHeader
                    isTemplate={isTemplate}
                    fieldValues={template.personal_information.knowledge_of_office}
                    baseName="personal_information[knowledge_of_office]"
                  />
                </div>
                <div className="col-12 px-7">
                  <div className="row">
                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="referred_by"
                      baseName="personal_information[knowledge_of_office][fields][who_refer_you]"
                      fieldValues={template.personal_information.knowledge_of_office.fields.who_refer_you}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />
                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="knowledge_of_office"
                      baseName="personal_information[knowledge_of_office][fields][how_choose_you_office]"
                      fieldValues={template.personal_information.knowledge_of_office.fields.how_choose_you_office}
                      component={Dropdown}
                      data={KNOWLEDGE_OF_OFFICE}
                      valueField="value"
                      textField="label"
                      wrapperClasses="col-6 form-group"
                    />
                  </div>
                </div>
              </div>
            </FormTemplateSectionWrapper>,

            <FormTemplateSectionWrapper isTemplate={isTemplate} fieldValues={template.personal_information.emergency_contact}>
              <div className="row mx-0 bg-white shadow-sm">
                <div className="col-12 px-5">
                  <FormTemplateHeader
                    isTemplate={isTemplate}
                    fieldValues={template.personal_information.emergency_contact}
                    baseName="personal_information[emergency_contact]" />
                </div>
                <div className="col-12 px-7 pt-5">
                  <div className="row">
                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="emergency_contact_name"
                      baseName="personal_information[emergency_contact][fields][emergency_contact_name]"
                      fieldValues={template.personal_information.emergency_contact.fields.emergency_contact_name}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="emergency_contact_relation"
                      baseName="personal_information[emergency_contact][fields][emergency_contact_relation]"
                      fieldValues={template.personal_information.emergency_contact.fields.emergency_contact_relation}
                      component={Input}
                      className="form-control"
                      wrapperClasses="col-6 form-group"
                    />

                    <FormTemplateField
                      isTemplate={isTemplate}
                      isOpen={true}
                      name="emergency_contact_phone"
                      baseName="personal_information[emergency_contact][fields][emergency_contact_phone]"
                      fieldValues={template.personal_information.emergency_contact.fields.emergency_contact_phone}
                      component={PhoneInput}
                      isPhoneInput={true}
                      className="form-control"
                      wrapperClasses="col-6 form-group emergency_contact_phone"
                    />


                  </div>
                </div>
              </div>
            </FormTemplateSectionWrapper>]
          }
        </div>
      }
    </div>
  )
}

const mapStateToProps = state => {
  const { auth } = state;
  return {
    userType: auth.user?.type
  }
}
export default connect(mapStateToProps)(PersonalInformationTab);
